// Tessitura
const automationData = {
  email: 'ml@gmail.com',
  password: 'password',
  genreConfig: {
    page: 1,
    selected: 'Recreation 2019'
  },
  eventsConfig: {
    page: 1,
    selected: 'TEA Linda Sasser'
  },
  tiersConfig: {
    selected: 'All Seats'
  }
};

export default automationData;
